import React from 'react';
import {
  baseIcon,
  iconDefaultProps,
} from './baseIcon';

const ArrowDownSolid = ({
 color, width, height, alt,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{alt}</title>

    <g
      id="Icon/arrowDown-solid"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <polygon
        id="Path-Copy-2"
        fill={color}
        transform="translate(12.333333, 12.000000) rotate(-270.000000) translate(-12.333333, -12.000000) "
        points="15.3333333 12 9.33333333 18 9.33333333 6"
      />
    </g>
  </svg>
);

ArrowDownSolid.defaultProps = iconDefaultProps;
ArrowDownSolid.propTypes = baseIcon;

export default ArrowDownSolid;
